import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import back from "../../back.png";
import ClientForm from "./ClientForm";
import FormatDecimal from "../../helpers/FormatDecimal";
import Invoices from "../calculate/Invoices";
import Contracts from "./Contracts";
import Services from "./Services";
import ClientFakForm from "./ClientFakForm";
import ClientLocks from "./ClientLocks";
import Transfers from "../calculate/Transfers";
import Calculate from "../calculate/Calculate";
import History from "../calculate/History";

import exmark from "../../exmark.png";
import Online from "./Online";


function ClientReview(props)
{

            const [row, setRow] = useState(null); 
            const [view, setView] = useState ( "list");

            const [selectedTab, setSelectedTab] = useState ( "faktury");


            const [infoCalculate, setInfoCalculate] = useState({
                saldo: 10.12,
                suma_po_terminie: 0.0,
                ostatnia_faktura: {
                    data: '____--__--__',
                    numer: '----',
                }
            });

            const [info, setInfo] = useState('');
            const [infoEdit, setInfoEdit] = useState(false);
            const [infoDraft, setInfoDraft] = useState('');


            const refreshAll = () => {
                getClientDet();
                getCalcDet();
            }


            const getClientInfo = () => {

                    fetch( Config.url + '/rest_v1_home,client_info_get', {
                        method: 'POST',
                        body: JSON.stringify( { id: props.id}),
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => {

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);
                                }else
                                {
                                    setInfo(res.result != undefined && res.result != null ? res.result : '');
                                }
                    } )
                    .catch(err => {
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    });

                    return false;
            }


            const editInfo = () => {
                setInfoDraft(info);
                setInfoEdit(true);
            }


            const cancelEditInfo = () => {
                setInfoEdit(false);
            }


            const saveInfo = () => {

                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1_home,client_info_set', {
                        method: 'POST',
                        body: JSON.stringify( { id: props.id, info: infoDraft}),
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => {

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);
                                }else
                                {
                                    setInfo(infoDraft);
                                    setInfoEdit(false);
                                }
                    } )
                    .catch(err => {
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });

                    return false;
            }


            const getClientDet = () => {
                    
            
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1_home,client_det', {
                        method: 'POST', 
                        body: JSON.stringify( { id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                 props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setRow(res.result);                                                 
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }

            
            const getCalcDet = () => {    

                 
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1_home,client_calc', {
                        method: 'POST', 
                        body: JSON.stringify( { id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setInfoCalculate(res.result);                                                 
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }    


            const changeView = (e ) => {
                    var v = e.target.getAttribute('v');
                    var id = e.target.getAttribute('id');

                    setView({...view, ["v"]:v, ["id"]:id });
            }


            const onBack = ( ) => {                
                setView({...view, ["v"]:"list", ["id"]:-1 });               
            }


            const onSuccess = ( ) => {                
                setView({...view, ["v"]:"list", ["id"]:-1 });       
                getClientDet();
            }



            const tabClick = (e) => {

                var v = e.target.getAttribute("tab");
                setSelectedTab(v);
            }

            


            const keyListener = (e) => {


                
                                var code = e.keyCode ? e.keyCode : e.which;    
                                console.log("keylockd", e.target.nodeName, code );

                                if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                                {
                                    e.target.blur();
                                }else 
                                if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                                {                                                                
                                } else
                                if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                                {
                                        props.onBack();                               
                                } else 
                                {
                                    props.keyListener(e);
                                }
                              
            }


                 useEffect(() => {
                                     

                        if(Config.env == "dev") console.log("ClientForm.js, listener on");
                        window.onkeydown = keyListener;

                        return () => {          
                            if(Config.env == "dev") console.log("ClientForm.js, listener off");      
                            window.onkeydown =  props.keyListener;
                        };

            });
        




            if(row == null)
            {
                getClientDet();
                getCalcDet();
                getClientInfo();
                return <div>
                </div>
            }



            if(view.v == "edit")
            {
                return <ClientForm  userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack}  onSuccess={onSuccess}   id={view.id} />
            }



            var cssFaktury   = "";
            var cssUmowy     = "";
            var cssUslugi    = "";
            var cssSaldo     = "";
            var cssPrzelewy  = "";
            var cssBlokady   = "";
            var cssOnline    = "";
            var cssFakturowanie    = "";
            var cssRozliczenia    = "";

            if(selectedTab == "faktury")  cssFaktury = "selected";
            if(selectedTab == "umowy")    cssUmowy = "selected";
            if(selectedTab == "uslugi")   cssUslugi = "selected";
            if(selectedTab == "saldo")    cssSaldo  = "selected";
            if(selectedTab == "przelewy") cssPrzelewy  = "selected";
            if(selectedTab == "blokady")  cssBlokady  = "selected";
            if(selectedTab == "online")   cssOnline  = "selected";
            if(selectedTab == "fakturowanie")   cssFakturowanie  = "selected";
            if(selectedTab == "rozliczenia")   cssRozliczenia  = "selected";



            if(row.nazwa.length > 1)
            {
              document.title = row.nazwa;
            }else  document.title = 'Dane klienta';


            return <div className="view_content">

                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                    <div className="location">Panel / Lista klientów / Szczegóły klienta</div>

                    <div className="app_header">{row.nazwa} <sup className="link_normal"  v="edit" id={row.id} onClick={changeView}>zmień dane klienta</sup></div>


                    <div className="client_info">                           
                           <div>NIP: {row.nip} </div>
                           <div>{row.zm_ulica} {row.zm_nr_domu} {row.zm_nr_mieszkania} {row.zm_kod_pocztowy} {row.zm_miejscowosc} </div>
                           <div>{row.telefon_kontaktowy} {row.email_kontaktowy}</div>
                           <div>
                                {   
                                    row.e_faktura == 1 &&
                                    <div>e-faktura: {row.e_mail_dla_faktur}</div>
                                }
                           </div>

                           {
                                      row.fakturowanie != undefined  && row.fakturowanie.aktualnie_wstrzymano_fakturowanie == '1' &&
                                      <div className="color_show4">     
                                        <br/>
                                        <img  className="tab_ico" src={exmark} title={"Fakturowanie wstrzymane od " +row.fakturowanie.wstrzymane_od   } />                                    
                                        Fakturowanie zostało wstrzymane ( {row.fakturowanie.wstrzymane_od } ), {row.fakturowanie.powod_wstrzymania}
                                        <br/>
                                      </div>
                           }

                    </div>
                    

                    <div className="client_info">
                        <div>
                            <b>Dodatkowe informacje</b>
                            {
                                infoEdit == false &&
                                <sup className="link_normal" onClick={editInfo}>edytuj</sup>
                            }
                        </div>

                        {
                            infoEdit == false &&
                            <div>
                                {
                                    info.length > 0 ? info : <i>brak dodatkowych informacji</i>
                                }
                            </div>
                        }

                        {
                            infoEdit == true &&
                            <div>
                                <textarea className="p100" rows="4" value={infoDraft} onChange={ (e) => setInfoDraft(e.target.value) } />
                                <br/>
                                <span className="btn" onClick={saveInfo}>Zapisz</span>
                                &nbsp;
                                <span className="link_normal" onClick={cancelEditInfo}>Anuluj</span>
                            </div>
                        }
                    </div>



                    <div className="client_info">                       
                
                        Aktualne saldo:&nbsp; 
                        {
                            infoCalculate.saldo >= 0 &&
                            <span className="bold_green"><FormatDecimal value={infoCalculate.saldo} /> zł </span>
                        }
                        {
                            infoCalculate.saldo < 0 &&
                            <span className="bold_red"><FormatDecimal value={infoCalculate.saldo} /> zł </span>
                        }   
                        <sup onClick={refreshAll} className="link_color">odśwież</sup>                     
                        &nbsp; 
                        Zaległości po terminie: <b><FormatDecimal value={infoCalculate.suma_po_terminie} /> zł </b>
                        &nbsp;
                        Ostatnio wystawiona faktura: <b>{infoCalculate.ostatnia_faktura.numer}</b> z dnia {infoCalculate.ostatnia_faktura.data}
                        &nbsp;
                        <sup onClick={refreshAll} className="link_color">odśwież</sup>
                    </div>


                    <div className="tabs">
                            <div className={"tab_items tab_items0 " + cssFaktury} onClick={tabClick} tab="faktury" >Faktury</div>
                            <div className={"tab_items tab_items1 " + cssUmowy} onClick={tabClick} tab="umowy" >Umowy</div>
                            <div className={"tab_items tab_items2 " + cssUslugi} onClick={tabClick} tab="uslugi" >Usługi</div>
                            <div className={"tab_items tab_items3 " + cssRozliczenia} onClick={tabClick} tab="rozliczenia" >Rozliczenia</div>
                            <div className={"tab_items tab_items4 " + cssPrzelewy} onClick={tabClick} tab="przelewy" >Przelewy </div>
                            <div className={"tab_items tab_items5 " + cssSaldo} onClick={tabClick} tab="saldo" >Historia salda</div>                                                    
                            <div className={"tab_items tab_items6" + cssBlokady} onClick={tabClick} tab="blokady" >Historia blokad</div>
                            <div className={"tab_items tab_items7" + cssOnline} onClick={tabClick} tab="online" >Użytkownicy OnLine</div>
                            <div className={"tab_items tab_items8" + cssFakturowanie} onClick={tabClick} tab="fakturowanie" >Ust. fakturowania</div>
                    </div>

                    <div className="tab_content">
                        
                            {
                                selectedTab == "faktury" &&
                                <Invoices  fak_kontrahenci_id={props.id} userData={props.userData} mainView={props.mainView} keyListener={keyListener} />
                            }


                            {
                                selectedTab == "umowy" &&
                                <Contracts  fak_kontrahenci_id={props.id} userData={props.userData} mainView={props.mainView} keyListener={keyListener} />
                            }

                              {
                                selectedTab == "uslugi" &&
                                <Services  fak_kontrahenci_id={props.id} userData={props.userData} mainView={props.mainView} keyListener={keyListener} />
                            }


                            {
                                selectedTab == "blokady" &&
                                <ClientLocks  fak_kontrahenci_id={props.id} userData={props.userData} mainView={props.mainView}  keyListener={keyListener}onBack={null} onSuccess={null}/>
                            }

                            {
                                selectedTab == "fakturowanie" &&
                                <ClientFakForm  id={props.id} userData={props.userData} mainView={props.mainView}  keyListener={keyListener} onBack={getCalcDet} onSuccess={getClientDet}/>
                            }

                              {
                                selectedTab == "przelewy" &&
                                <Transfers  fak_kontrahenci_id={props.id} userData={props.userData} mainView={props.mainView} keyListener={keyListener} />
                            }

                              {
                                selectedTab == "rozliczenia" &&
                                <Calculate  fak_kontrahenci_id={props.id} userData={props.userData} mainView={props.mainView} keyListener={keyListener} />
                            }

                            {
                                selectedTab == "saldo" &&
                                <History  fak_kontrahenci_id={props.id} userData={props.userData} mainView={props.mainView} keyListener={keyListener} />
                            }

                            {
                                selectedTab == "online" &&
                                <Online  fak_kontrahenci_id={props.id} userData={props.userData} mainView={props.mainView} keyListener={keyListener} />
                            }

                    </div>

            </div>
}


export default ClientReview;